import React from "react";
import { CheckCircle2, AlertTriangle, XCircle, Hourglass } from "lucide-react";

/**
 * Qualification mapping (driven by match_score 0-100):
 *   >= 60 → qualified (green)
 *   40-59 → needs_review (orange)
 *   <  40 → not_qualified (red)
 *   null  → pending (slate)
 */
export function qualificationFromScore(score) {
  if (score == null) return "pending";
  if (score >= 60) return "qualified";
  if (score >= 40) return "needs_review";
  return "not_qualified";
}

const CONFIG = {
  qualified:     { en: "Qualified",     fr: "Qualifié",      cls: "bg-emerald-100 text-emerald-700 border-emerald-200", Icon: CheckCircle2 },
  needs_review:  { en: "Needs review",  fr: "À revoir",      cls: "bg-amber-100 text-amber-700 border-amber-200",       Icon: AlertTriangle },
  not_qualified: { en: "Not qualified", fr: "Non qualifié",  cls: "bg-rose-100 text-rose-700 border-rose-200",          Icon: XCircle },
  pending:       { en: "Pending",       fr: "En attente",    cls: "bg-slate-100 text-slate-600 border-slate-200",       Icon: Hourglass },
};

export default function QualificationBadge({ score, qualification, lang = "en", size = "sm" }) {
  const q = qualification || qualificationFromScore(score);
  const cfg = CONFIG[q] || CONFIG.pending;
  const Icon = cfg.Icon;
  const text = lang === "fr" ? cfg.fr : cfg.en;
  const padding = size === "lg" ? "px-3 py-1 text-xs" : "px-2 py-0.5 text-[11px]";
  return (
    <span data-testid={`qualification-${q}`} className={`inline-flex items-center gap-1 rounded-full border ${padding} font-medium ${cfg.cls}`}>
      <Icon className="h-3 w-3" />
      {text}
    </span>
  );
}

export function MatchScoreBadge({ score, lang = "en" }) {
  if (score == null) {
    return <span className="inline-flex items-center text-xs text-slate-400" data-testid="match-score-pending">{lang === "fr" ? "…" : "…"}</span>;
  }
  const color = score >= 60 ? "text-emerald-600" : score >= 40 ? "text-amber-600" : "text-rose-600";
  return (
    <span data-testid={`match-score-${score}`} className={`inline-flex items-center gap-0.5 font-bold ${color}`}>
      {score}
      <span className="text-[10px] text-slate-400 font-normal">/100</span>
    </span>
  );
}
